import { Box, Button } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MainPage = () => {
  const navigate = useNavigate();

  const onClickAdmin = () => {
    navigate("/admin");
  };

  useEffect(() => {
    onClickAdmin();
  }, []);

  const onClickRecruiter = () => {
    navigate("/recruiter");
  };

  const onClickArtist = () => {
    navigate("/artist");
  };

  return (
    <Box className="flex flex-col items-center justify-center gap-6 h-screen bg-white">
      {/* <div className="font-['CG-Medium'] text-8xl text-[#5c5f62] whitespace-nowraptext-[32px] tracking-[0.15em]">
                STARNEX
            </div> */}
      <div className="max-w-[500px] self-center">
        <img
          src={require("./assets/images/white-bg-logo.png")}
          className={"w-full"}
        />
      </div>
      <div className="flex flex-wrap gap-6 px-3 ">
        <Button
          className="bg-[#2F80ED] text-white min-w-[130px]"
          onClick={onClickAdmin}
        >
          Admin
        </Button>
        <Button
          className="bg-[#b6cdeb] text-white min-w-[130px]"
          onClick={onClickRecruiter}
          disabled
        >
          Recruiter
        </Button>
        <Button
          className="bg-[#b6cdeb] text-white min-w-[130px]"
          onClick={onClickArtist}
          disabled
        >
          Artist
        </Button>
      </div>
    </Box>
  );
};

export default MainPage;
